import { memo, useMemo } from 'react';
import { useTheme } from '@mui/material/styles';
import { Box, Drawer, Stack, useMediaQuery } from '@mui/material';
import PerfectScrollbar from 'react-perfect-scrollbar';
import MenuList from './MenuList';
import LogoSection from '../LogoSection';
import MiniDrawerStyled from './MiniDrawerStyled';
import LAYOUT_CONST from 'store/constant';
import useConfig from 'hooks/useConfig';
import { drawerWidth } from 'store/constant';
import { useDispatch, useSelector } from 'store';
import { openDrawer, activeItem } from 'store/slices/menu';
import React from 'react';
import { Route, Link, Routes, useLocation } from 'react-router-dom';

const Sidebar = (props) => {
    const theme = useTheme();
    const matchUpMd = useMediaQuery(theme.breakpoints.up('md'));
    const matchDownMd = useMediaQuery(theme.breakpoints.down('md'));
    const dispatch = useDispatch();
    const { layout, drawerType } = useConfig();
    const location = useLocation();
    const { selectedItem, drawerOpen } = useSelector((state) => state.menu);

    if (location.pathname === '/dashboard') {
        if (selectedItem && selectedItem.length && selectedItem[0] !== 'Dashboard') {
            dispatch(activeItem(['Dashboard']));
        }
    }

    if (location.pathname === '/admin/list') {
        if (selectedItem && selectedItem.length && selectedItem[0] !== 'admins') {
            dispatch(activeItem(['admins']));
        }
    }

    if (location.pathname === '/app-user/list' || location.pathname.includes('/app-user/profile')) {
        if (selectedItem && selectedItem.length && selectedItem[0] !== 'app-users') {
            dispatch(activeItem(['app-users']));
        }
    }

    const logo = useMemo(
        () => (
            <Box sx={{ display: 'flex', p: { xs: 2, lg: '0 20px' } }}>
                <LogoSection />
            </Box>
        ),
        []
    );

    const drawerContent = (
        <>
            <MenuList />
            {layout === LAYOUT_CONST.VERTICAL_LAYOUT && drawerOpen}
        </>
    );

    const drawerSX = {
        paddingLeft: drawerOpen ? '16px' : 0,
        paddingRight: drawerOpen ? '16px' : 0,
        marginTop: drawerOpen ? 0 : '20px'
    };

    const drawer = useMemo(
        () => (
            <>
                {matchDownMd ? (
                    <Box sx={drawerSX}>{drawerContent}</Box>
                ) : (
                    <PerfectScrollbar
                        component="div"
                        style={{
                            height: !matchUpMd ? 'calc(100vh - 56px)' : 'calc(100vh - 76px)',
                            // ...drawerSX,
                            padding: !matchUpMd ? '0 16px' : '18px 20px 0'
                        }}
                    >
                        {drawerContent}
                    </PerfectScrollbar>
                )}
            </>
        ),
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [matchUpMd, drawerOpen, drawerType]
    );

    return (
        <Box
            className="sidebar-nav"
            component="nav"
            sx={{ flexShrink: { md: 0 }, width: matchUpMd ? drawerWidth : 'auto' }}
            aria-label="mailbox folders"
        >
            {matchDownMd || (drawerType === LAYOUT_CONST.MINI_DRAWER && drawerOpen) ? (
                <Drawer
                    variant={matchUpMd ? 'persistent' : 'temporary'}
                    anchor="left"
                    open={drawerOpen}
                    onClose={() => dispatch(openDrawer(!drawerOpen))}
                    sx={{
                        '& .MuiDrawer-paper': {
                            mt: matchDownMd ? 0 : 11,
                            zIndex: 1099,
                            width: drawerWidth,
                            background: theme.palette.background.default,
                            color: theme.palette.text.primary,
                            borderRight: 'none'
                        }
                    }}
                    ModalProps={{ keepMounted: true }}
                    color="inherit"
                >
                    {matchDownMd && logo}
                    {drawer}
                </Drawer>
            ) : (
                <MiniDrawerStyled variant="permanent" open={drawerOpen}>
                    {logo}
                    {drawer}
                </MiniDrawerStyled>
            )}
        </Box>
    );
};

export default memo(Sidebar);
